export const reasonMap = {
    not_aligned_with_franchise_model:"Negotiation didn't workout",
    not_agreeing_with_tr_standards:"Property not upto OYO standards",
    not_agreeing_to_branding_requirements:"Negotiation didn't workout",
    wrong_contact_number:"Wrong contact info",
    too_far_away_from_operational_area:"Too far away from operational area",
    wrong_incomplete_address:"Wrong/incomplete address",
    duplicate_lead:"Duplicate lead",
    selected_wrong_purpose_of_the_lead:"Selected wrong purpose of the lead",
    property_does_not_exist_at_given_address:"Wrong/incomplete address",
    accepted_audit_needs_to_be_modified:"Accepted Audit needs to be modified",
    can_not_be_transformed_in_a_bad_shape:"Property not upto OYO standards",
    property_already_live_with_oyo:"Property already live with OYO",
    does_not_like_the_commercials:"Negotiation didn't workout",
    not_agreeing_with_perfect_smart:"Negotiation didn't workout",
    does_not_wish_to_run_property:"Negotiation didn't workout",
    does_not_have_legal_licenses:"Legal/compliance issue",
    got_negative_feedback_from_market:"Negotiation didn't workout",
    creating_new_lead_against_same:"Creating new lead against same",
    future_valid:"Future valid",
    others:"Others",
    oyo_not_operating_in_the_region:"OYO not operating in the region",
    user_unresponsive_for_long:"User unresponsive for long"
};